import styles from "./styles.module.scss";

export const AdvertBanner = ({ items = [], className = "" }) => {
  return (
    <section className={`${styles.root} ${className}`}>
      <div className={styles.grid}>
        {items.map(({ image, link, backgroundColor }, index) => {
          const inlineStyle = image?.url
            ? { backgroundImage: `url(${image.url})` }
            : {};

          const cardClassName = `${styles.card}${
            backgroundColor ? ` ${backgroundColor}` : ""
          }`;

          return (
            <a
              key={index}
              href={link || "#"}
              className={cardClassName}
              data-sourceflow-prop="items"
              style={inlineStyle}
            />
          );
        })}
      </div>
    </section>
  );
};

export default AdvertBanner;
